import React, { useEffect } from "react";
import CustomInput from "../../../common/components/CustomInput/CustomInput.jsx";

import FormWarning from "./FormWarning";

const EasyPhoneNumber = props => {
  const { propName } = props;
  const setPropMounted = props.connectForm.setPropMounted;

  useEffect(() => {
    setPropMounted(propName, true);
    return () => {
      setPropMounted(propName, false);
    };
  }, [setPropMounted, propName]);

  function transformPhoneNumber(value) {
    const digits = String(value || "").replace(/\D/g, "");
    const phoneDigits =
      digits.length === 11 && digits[0] === "1"
        ? digits.slice(1, 11)
        : digits.slice(0, 10);
    const extensionDigits =
      digits.length === 11 && digits[0] === "1"
        ? digits.slice(11, 16)
        : digits.slice(10, 15);

    if (phoneDigits.length === 0) {
      return "";
    }

    if (phoneDigits.length < 4) {
      return "(" + phoneDigits;
    }

    if (phoneDigits.length < 7) {
      return `(${phoneDigits.slice(0, 3)}) ${phoneDigits.slice(3)}`;
    }

    const formattedPhone = `(${phoneDigits.slice(0, 3)}) ${phoneDigits.slice(
      3,
      6
    )}-${phoneDigits.slice(6)}`;

    if (extensionDigits.length > 0) {
      return `${formattedPhone} Ext. ${extensionDigits}`;
    }

    return formattedPhone;
  }

  return (
    <div>
      <CustomInput
        success={props.connectForm.getState(propName) === "Success"}
        error={props.connectForm.getState(propName) === "Error"}
        labelText={
          <span>
            {(props.labelText || props.connectForm.getLabel(propName)) + " "}
            {props.connectForm.isRequired(propName) ? <span>*</span> : ""}
          </span>
        }
        id={propName}
        formControlProps={{
          fullWidth: true
        }}
        inputProps={{
          type: "tel",
          onChange: event =>
            props.connectForm.change(
              transformPhoneNumber(event.target.value),
              propName
            ),
          value: props.connectForm.getValue(propName),
          autoComplete: "off"
        }}
      />
      <FormWarning
        isValid={props.propName}
        isError={props.connectForm.getState(propName)}
        errorMessage={props.connectForm.getErrorMessage(propName)}
      />
    </div>
  );
};

export default EasyPhoneNumber;
